import { Realty, services } from '@ambita/ambita-components-core';
import { ApiAffair } from '../../../typings/CadastreReport';

const util = services.util;

function transformAffairs(affairsData: Realty.ApiResponse) {
  if (affairsData.items && affairsData.items.length > 0) {
    const affairs: ApiAffair[] = affairsData.items;
    const retObject: any = {
      affairs: []
    };

    affairs.forEach((affair: ApiAffair) => {
      retObject.affairs.push(util.pick(affair, [
        'typeOfAffair',
        'affairDocumentDate',
        'landRegistryRegisteredDate',
        'cadastreAffairs'
      ]));
    });

    retObject.affairs = retObject.affairs.reverse();

    return retObject;
  }
}

export default transformAffairs;
